module.exports = __webpack_public_path__ + "static/media/mg.7a54f12d.svg";